<ng-container *transloco="let t">
  @if (isMismatch()) {
    <IPopover>
      <IBadge
        iPopoverTrigger
        placement="top-center"
        [hoverMode]="true"
        [label]="budgetCurrency()"
        color="orange"
        variant="soft"
        class="select-none"
        icon="infoCircle"
      />
      <ng-template iPopoverContent>
        <div
          class="popover-container flex flex-col gap-1 p-3 text-sm"
          animate.enter="popover-animate-enter"
          animate.leave="popover-animate-leave"
          data-placement="top-center"
        >
          <div class="flex items-center gap-1 text-gray-500">
            <IIcon name="infoCircle" />
            {{ t("budget-currency-badge.differs") }}
          </div>
          @if (convertedAmount()) {
            <div class="text-lg text-gray-800">
              &approx; {{ convertedAmount() | number: "1.0-2" : locale() }} {{ selectedCurrency() }}
            </div>
          }
          <div class="text-xs text-gray-500">
            {{
              t("budget-currency-badge.today_rate", [
                budgetCurrency(),
                rate() | number: "1.2-4" : locale(),
                selectedCurrency(),
              ])
            }}
          </div>
        </div>
      </ng-template>
    </IPopover>
  } @else {
    <IBadge [label]="budgetCurrency()" color="gray" class="select-none" />
  }
</ng-container>
